import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";

export default function BannerBtn ({ buttonColor, buttonHoverColor, buttonText, buttonTextColor, url, defaultBtnClassName, buttonShape, btnAniDir, btnAniDelay, bannerId, data }) {

  let btnHoverColor = buttonHoverColor
  let hoverClr = btnHoverColor ? btnHoverColor : ""

  const isExternalUrl = url.startsWith('http');
  const [buttonToShow, setButtonToShow] = useState('')

  useEffect(() => {
    if (!btnHoverColor && btnHoverColor == "undefined") {
      btnHoverColor = "orange"
    }
  }, [buttonHoverColor])

  useEffect(() => {
    getButtonToShow();
  }, [buttonColor, buttonHoverColor, buttonText, buttonTextColor, url, defaultBtnClassName, buttonShape, btnAniDir, btnAniDelay, bannerId, data])

  const getButtonToShow = () =>{
    let btnToShow = null;
    if(buttonColor){
      if(!isExternalUrl){
        btnToShow = (
          <Link
            className={`animated dtn_over${bannerId} ${buttonShape} ${btnAniDir} ${btnAniDelay}`}
            to={process.env.PUBLIC_URL + url}
            style={{
              backgroundColor: `${buttonColor}`,
              color: `${buttonTextColor}`,
              border: 'none',
              borderRadius: `${data.buttonBorder}`  || '',
              fontWeight: data.buttonFontStyle?.indexOf('bold') >=0 ? 'bold': '',
              textDecoration: data.buttonFontStyle?.indexOf('underline') >=0 ? 'underline': '',
              fontSize: `${data.buttonFontSize || ''}px`,
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = btnHoverColor
              e.target.style.color = "#FFFFFF"
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = buttonColor
              e.target.style.color = buttonTextColor
            }}
            >
            {buttonText}
          </Link>
        )
      }else{
        btnToShow = (
          <a
            className={`animated dtn_over${bannerId} ${buttonShape} ${btnAniDir} ${btnAniDelay}`}
            href={process.env.PUBLIC_URL + url}
            target='_blank'
            style={{
              backgroundColor: `${buttonColor}`,
              color: `${buttonTextColor}`,
              border: 'none',
              borderRadius: `${data.buttonBorder}`  || '',
              fontWeight: data.buttonFontStyle?.indexOf('bold') >=0 ? 'bold': '',
              textDecoration: data.buttonFontStyle?.indexOf('underline') >=0 ? 'underline': '',
              fontSize: `${data.buttonFontSize || ''}px`,
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = btnHoverColor
              e.target.style.color = "#FFFFFF"
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = buttonColor
              e.target.style.color = buttonTextColor
            }}
          >
            {buttonText}
          </a>
        )
      }
    }else{
      if(!isExternalUrl){
        btnToShow = (
          <Link className={`animated dtn_over${bannerId} ${buttonShape}`} to={process.env.PUBLIC_URL + url}
                style={
                  {
                    backgroundColor: data.btncolor,
                    borderRadius: data.buttonBorder || '',
                    fontWeight: data.buttonFontStyle?.indexOf('bold') >=0 ? 'bold': '',
                    textDecoration: data.buttonFontStyle?.indexOf('underline') >=0 ? 'underline': '',
                    fontSize: `${data.buttonFontSize || ''}px`,
                  }
                }
                >
            {buttonText}
          </Link>
        )
      }else{
        btnToShow = (
          <a
            target='_blank'
            className={`animated dtn_over${bannerId} ${buttonShape}`} to={process.env.PUBLIC_URL + url}
            style={
                  {
                    backgroundColor: data.btncolor,
                    borderRadius: data.buttonBorder || '',
                    fontWeight: data.buttonFontStyle?.indexOf('bold') >=0 ? 'bold': '',
                    textDecoration: data.buttonFontStyle?.indexOf('underline') >=0 ? 'underline': '',
                    fontSize: `${data.buttonFontSize || ''}px`,
                  }
                }
          >
            {buttonText}
          </a>
        )
      }
    }
    setButtonToShow(btnToShow)
  }
  return (
    <>
      <style >
      {`.dtn_over${bannerId}{
                border-color:${data?.btnBordercolor} !important
                }
                .dtn_over${bannerId}:hover {
                                      background: ${hoverClr} !important;
                      border-color:${data?.buttonBorderHoverColor} !important;
                      
                          }`
        }
      </style>
      <div className={`${defaultBtnClassName} ${data.buttonBorder === '50px' ? 'btn-hover-r': ''}`} >
        {buttonToShow}
      </div>
    </>
  );
}
